import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class PartnerService
    extends BaseService {

    static async list(param) {
        return BaseService.callAPI('sub-agency/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('sub-agency/get/' + id);
    }

    static async save(partner) {
        return BaseService.callAPI('sub-agency/save', partner);
    }

    static async delete(id) {
        return BaseService.callAPI('sub-agency/delete/' + id);
    }

    static async uploadPhoto(id, file) {
        return BaseService.postFile('sub-agency/upload-photo/' + id, file);
    }

    static async addInstructor(subAgencyID, instructorID, force) {
        return BaseService.callAPI('sub-agency/add-instructor', {
            subAgencyID, instructorID, force
        });
    }

    static async removeInstructor(subAgencyID, instructorID) {
        return BaseService.callAPI('sub-agency/remove-instructor', {
            subAgencyID, instructorID
        });
    }

    static async addUser(subAgencyID, userID, force) {
        return BaseService.callAPI('sub-agency/add-user', {
            subAgencyID, userID, force
        });
    }

    static async removeUser(subAgencyID, userID) {
        return BaseService.callAPI('sub-agency/remove-user', {
            subAgencyID, userID
        });
    }
}
